module.exports = __webpack_public_path__ + "media/application/images/demo/adv_300x250-db3beb84f2ef8fba9cd85b8fa8e3d055.jpg";